import PropTypes from 'prop-types';
import React from 'react';
import styles from './CloseBtn.module.scss';
import IconClose from '../../../../images/icons/misc/close.svg';


export default function CloseBtn({ onClick, className, title }) {
  return (<IconClose
    role="button"
    onClick={onClick}
    title={title}
    className={`${styles.icon} ${className}`}
  />);
}

CloseBtn.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string
};

CloseBtn.defaultProps = {
  className: '',
  title: ''
};
